module.exports = __webpack_public_path__ + "img/logotop.e19d093e.png";